<template>
  <div v-if="images.length > 0">
    <div class="flex items-center justify-between bg-cover bg-center rounded h-48 md:h-84" :style="`background-image:url('${active}')`">
      <button class="h-8 w-8 bg-white ml-4 rounded focus:outline-none shadow" @click.prevent="prev">
        <font-awesome-icon :icon="['far', 'chevron-left']"></font-awesome-icon>
      </button>
      <button class="h-8 w-8 bg-white mr-4 rounded focus:outline-none shadow" @click.prevent="next">
        <font-awesome-icon :icon="['far', 'chevron-right']"></font-awesome-icon>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageCarousel',
  data () {
    return {
      index: 0
    }
  },
  computed: {
    active () {
      return this.images.length > 0 ? this.images[this.index] : null
    }
  },
  props: {
    images: {
      type: Array,
      required: true
    }
  },
  methods: {
    prev () {
      if (this.index > 0) {
        this.index -= 1
      }
    },
    next () {
      if (this.index < this.images.length - 1) {
        this.index += 1
      }
    }
  }
}
</script>